<div class="card shadow-sm rounded-0 border-0 h-100" id="newsComponentFieldset" name="newsComponentFieldset">
     <div class="card-body">
          <h2 id="newsHeaderDiv" class="card-title h5 mt-0"> 
               <span
                    [innerHtml]="'News' | translator: 'base'"
               >News</span>
          </h2>
          <p class="news-item">
               {{ firstItemTitle }}
          </p>
          <hr />
          <p class="news-item">
               {{ secondItemTitle }}
          </p>
          <button
               [routerLink]="'/news'"
               (click)="scrollToTop()" 
               class="btn btn-outline-primary btn-sm"
               [title]="'ReadMore' | translator: 'base'"
               name="newsLink"
               id="newsLink"
          >
               <span [innerHTML]="'ReadMore' | translator: 'base'">Read More</span>
          </button>
     </div>
     <div class="psuedo-hidden" [innerHtml]="translate('Voodoo')" >Voodoo!!! DO NOT CHANGE TO display:none or translation won't be triggered and grid language will not change on language drop down change.</div>
</div>